import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, InputNumber, Button } from 'antd';

const FormItem = Form.Item;

const labelColXsSpan = 4;
const formItemLayout = {
  labelCol: {
    xs: { span: labelColXsSpan },
  },
  wrapperCol: {
    xs: { span: 6 },
  },
};

const submitBtnLayout = {
  wrapperCol: {
    xs: {
      offset: labelColXsSpan,
    },
  },
};

class NewCacFinancialsForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    this.setState({
      submittingForm: true,
    });
    event.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({
        submittingForm: false,
      });
      if (!err) {
        this.props.submitFormData(values);
      } else {
        console.log(err);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem
          hasFeedback
          label="Current year"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'current_year',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<InputNumber min={1950} step={1} />)
          }
        </FormItem>
        <FormItem
          hasFeedback
          label="No. of audited years"
          {...formItemLayout}
        >
          {
            getFieldDecorator(
              'audited_years_count',
              {
                rules: [
                  {
                    required: true,
                    message: 'Field is required!',
                  },
                ],
              },
            )(<InputNumber min={1} step={1} />)
          }
        </FormItem>
        <FormItem {...submitBtnLayout}>
          <Button type="primary" htmlType="submit" loading={this.state.submittingForm}>Submit</Button>
        </FormItem>
      </Form>
    );
  }
}

NewCacFinancialsForm.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  submitFormData: PropTypes.func.isRequired,
};

export default Form.create()(NewCacFinancialsForm);



// WEBPACK FOOTER //
// ./src/forms/NewCacFinancialsForm.jsx